export default __webpack_public_path__ + "static/media/red-sphere.b8a172ed.png";